import React from "react";
import { useSelector } from "react-redux";
import { Redirect as ReactRouterRedirect } from "react-router-dom";
import { userGetInventoryTypeSelector } from "src/store/system/selector";

import { Entries } from "./Menu";

function Redirect() {
  const inventoryType = useSelector(userGetInventoryTypeSelector);
  const to = Entries.find((entry) =>
    entry.inventoryType && entry.inventoryType !== inventoryType ? false : true
  )?.to;

  if (!to) return null;
  return <ReactRouterRedirect to={to} />;
}

export default Redirect;
